export const waitDateFields = catalog =>
  (catalog?.condition_fields?.appointment || catalog?.fields || []).filter(
    field => field.is_date === true || field.type === 'timestamp'
  );

export const waitSources = event => [
  'appointment',
  'event',
  ...(['updated', 'deleted'].includes(event) ? ['previous'] : []),
];

export const settingsMessages = {
  en: {
    nodeSettings: {
      configure: 'Configure step',
      draftHint:
        'Apply settings to this step, then save the workflow draft. Cancel leaves the step unchanged.',
      context:
        'This workflow checks the patient, the appointment that triggered it, and products of that appointment. It does not select another appointment automatically.',
      unavailable: 'Saved value is unavailable for this trigger',
      fieldHint:
        'Only appointment date fields are available. Previous values require an updated or deleted appointment event.',
    },
  },
  ru: {
    nodeSettings: {
      configure: 'Настроить блок',
      draftHint:
        'Примените настройки к блоку, затем сохраните черновик сценария. «Отмена» оставит прежние значения.',
      context:
        'Проверяются пациент, запись, запустившая сценарий, и товары именно этой записи. Другая запись пациента автоматически не выбирается.',
      unavailable: 'Сохранённое значение недоступно для этого запуска',
      fieldHint:
        'Доступны только поля дат записи. Предыдущие значения можно использовать при изменении или удалении записи.',
    },
  },
};
